import "./caseStudyStyles.css";
import { useNavigate } from "react-router-dom";
// import animationData from "./screen2.mov";
import Header from "./Header";
import piece8 from "./screen3.png";
// import piece9 from "./screen4.png";
// import piece10 from "./screen5.png";
// import piece22 from "./4main.png";
// import piece23 from "./6main.png";
// import piece24 from "./7main.png";
// import piece25 from "./2main.png";
// import piece26 from "./9main.png";
// import piece27 from "./8main.png";
// import piece28 from "./5main.png";
// import piece29 from "./10main.png";

export default function Gallery2() {
  const navigate = useNavigate();
  return (
    <div class="case-study-page">
      <Header />
      <section className="hero-section">
        <section class="device-showcase" style={{ maxWidth: "1200px" }}>
          <button onClick={() => navigate(-1)} style={{ width: "fit-content", color: "rgb(152, 192, 239)", background: "none", border: "none", cursor: "pointer", fontSize: "20px" }}>
            ← Back
          </button>
          {/* <div class="device-frame" style={{ height: "825px", background: "none" }}>
            <video autoPlay loop muted playsInline style={{ height: "stretch" }}>
              <source src={animationData} type="video/mp4" />
            </video>
          </div> */}
          <div class="device-frame">
            <img src={piece8} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
          </div>
          {/* <div class="device-frame">
            <img src={piece9} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
          </div>
          <div class="device-frame">
            <img src={piece10} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
          </div> */}
        </section>
      </section>
    </div>
  );
}
